import { OptionsApi } from '@core/swagger-client';
import { ErrorMessagePage, LoaderPage } from '@core/ui';
import { useParams } from '@online-webinar/router';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthPageTitle } from '../../atoms';
import { AuthFormBroadcasterHeader } from '../../molecules/AuthFormBroadcasterHeader';
import { AuthFormModeratorHeader } from '../../molecules/AuthFormModeratorHeader';
import { AuthPage, AuthPageContent, ForgotPassword, Login, Register, RegisterSideContent } from '../../organism';

export const AccountWizardPage = ({ isModerator, isBroadcaster }: { isModerator?: boolean; isBroadcaster?: boolean }) => {
    const { webinarId } = useParams({ strict: false });
    const { t } = useTranslation();

    const [mode, setMode] = useState<'login' | 'register' | 'forgot-password'>('login');
    const [email, setEmail] = useState<string>();

    const { isLoading, data: webinar, error } = useQuery(OptionsApi.webinar.get(webinarId!, { enabled: !!webinarId, staleTime: 60_000 }));

    if (error) return <ErrorMessagePage apiError={error} />;
    if (isLoading) return <LoaderPage />;

    return (
        <AuthPage>
            <AuthPageContent>
                <AuthPageTitle className="mb-8">{t('Pages.Login.Header')}</AuthPageTitle>
                {webinar && isModerator && <AuthFormModeratorHeader webinar={webinar} />}
                {webinar && isBroadcaster && <AuthFormBroadcasterHeader webinar={webinar} />}
                {mode === 'login' && (
                    <Login
                        onRegister={(emailAddress: string) => {
                            setEmail(emailAddress);
                            setMode('register');
                        }}
                        onForgotPassword={(emailAddress: string) => {
                            setEmail(emailAddress);
                            setMode('forgot-password');
                        }}
                    />
                )}
                {mode === 'register' && <Register emailAddress={email} quickRegister={!!webinarId} onBack={() => setMode('login')} />}
                {mode === 'forgot-password' && <ForgotPassword emailAddress={email} onBack={() => setMode('login')} />}
            </AuthPageContent>
            <RegisterSideContent />
        </AuthPage>
    );
};
